import type { ChatBotSettings, LiveChatAppSettings } from "./types";

export const LIVE_CHAT_DEFAULT_SETTINGS: LiveChatAppSettings = {
  browserTabTitle: "Support",
  faviconUrl: "",
  businessName: "Support",
  businessLogoUrl: "",
  agentName: "AI Agent",
  agentImage: "",
  customButton: null,
  theme: "light",
  senderMessageBackgroundColor: "#1A75D2",
  suggestions: [],
  ctaTitle: "Welcome to the support chat!",
  ctaSubtitle: "",
  ctaVisual: null,
};

export const CHAT_BOT_DEFAULT_SETTINGS: ChatBotSettings = {
  chatName: "Support",
  chatImageUrl: "",
  agentName: "AI Agent",
  agentImage: "",
  welcomeMessage: "Hello! How can I help you?",
  theme: "light",
  senderMessageBackgroundColor: "#1A75D2",
  suggestions: [],
  buttonIcon: "default-1",
  buttonColor: "#1A75D2",
  alignment: "right",
  sideSpacing: 20,
  bottomSpacing: 20,
  isButtonHidden: false,
  ctas: [],
  ctaVisual: null,
};

export const MAX_CTA_LENGTH = 100;

export const MAX_CHAT_NAME_LENGTH = 60;

export const MAX_AGENT_NAME_LENGTH = 60;

/** Identifier for the client message to satisfy the `from` field in the ChatBotMessageModel */
export const CLIENT_MESSAGE_FROM_ID = "client";

/** Identifier for AI agent messages */
export const AI_AGENT_MESSAGE_FROM_ID = "00000000-0000-0000-0000-000000000000";

/** Unique ID assigned to the synthetic welcome message injected on first load */
export const WELCOME_MESSAGE_ID = "welcome";

/** Timeout for the AI typing indicator */
export const TYPING_INDICATOR_TIMEOUT = 30_000;
